// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NOK5","icon":"styles_icon__3W3ir"};